<template>
  <el-dialog
      :visible.sync="visible"
      title="销售开票申请"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="95%"
      :append-to-body="true"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="客户：" prop="customerId" label-width="80px">
            <el-select v-model="dataForm.customerId" size="mini" style="width: 100%" :filterable="true"
                       @change="customerChanged">
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="税号：" prop="taxCode" label-width="80px">
            <el-input v-model="dataForm.taxCode" placeholder="请输入税号" size="mini">></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发货日期：" prop="shipDate">
            <el-date-picker v-model="dataForm.shipDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"
                            placeholder="选择发货日期" size="mini">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="8">
          <div style="display: flex;align-items: center;height: 59px;">
            <el-checkbox v-model="dataForm.isOldStore" true-label="是" false-label="否" label="库存发货(供应商直接发货给客户的情况不需要勾选)"
                         style="margin-bottom: 22px;"></el-checkbox>
            <el-form-item label="发货工厂："  >
              <company ref="company" v-model="sendFactory.id" ></company>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行：" prop="bank" label-width="80px">
            <el-input v-model="dataForm.bank" placeholder="请输入银行" size="mini">></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行账号：" prop="accountCode">
            <el-input v-model="dataForm.accountCode" placeholder="请输入银行账号" size="mini">></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <div class="table-bar" id="tableBar" style="justify-content: flex-start;align-items: center;margin-bottom: 0;">
        <div>
          <el-button size="mini" icon="el-icon-plus" @click="showMakeDetailDialog" type="primary">选择品番
          </el-button>
          <el-button size="mini" icon="el-icon-plus" @click="showPurchaseDialog"  type="warning">选择物料
          </el-button>
        </div>
      </div>
      <SweetTable :data="dataForm.detailList" empty-text="请选择或导入发货品番" :is-page="false"
                  :height="500">
        <el-table-column label="外销合同号" prop="agreementCode" align="center" width="160"
                         :show-tooltip-when-overflow="true">
        </el-table-column>
        <el-table-column label="出货工厂" align="center" width="160" prop="factoryName"
                         :formatter="$c.companyNameFormatter" :show-tooltip-when-overflow="true">
        </el-table-column>
        <el-table-column label="货品信息" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="发货数量" prop="totalCount" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.totalCount'" :rules="detailRule.totalCount"
                          label-width="0"
                          style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.totalCount" placeholder="出货单价"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="发货单价" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.price'" :rules="detailRule.price" label-width="0"
                          style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.price" placeholder="出货单价"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="100" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-remove" type="text" @click="delRow(scope.$index, scope.row)">
              移除
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="doSubmit()" size="mini">{{ $t('confirm') }}
      </el-button>
    </template>
    <MakeDetailDialog ref="MakeDetailDialog" @selected="makeDetailSelected"></MakeDetailDialog>
    <PurchaseDialog ref="PurchaseDialog" @selected="purchaseSelected"></PurchaseDialog>
  </el-dialog>
</template>

<script>
import PurchaseDialog from '@/views/modules/erp/purchase/purchase-dialog.vue'
import { moneyValidator } from '@/utils/validate'
import BigNumber from 'bignumber.js'
import ProductRowCard from '@/components/ProductRowCard.vue'
import MakeDetailDialog from '@/views/modules/erp/make/make-detail-dialog.vue'

/**
 * 销售开票(内销发货单)创建/编辑
 */
export default {
  name: 'create-inner-box-dialog',
  components: { ProductRowCard, MakeDetailDialog, PurchaseDialog },
  data () {
    return {
      sendFactory: {
        id: '',
        name: ''
      },
      customerList: [],
      dataForm: {
        isOldStore: '否',
        detailList: []
      },
      visible: false
    }
  },
  watch:{
    'sendFactory.id':{
      handler(val){
        this.sendFactory.name=this.$refs.company.getCompanyName(val)
        this.dataForm.detailList.forEach(row=>{
          row.factoryId=val
          row.factoryName=this.sendFactory.name
        })
      }
    }
  },
  computed: {
    detailRule () {
      const numValidate = function (rule, value, callback) {
        if (!value) {
          callback()
        }
        let reg = /\d+/g
        if (!reg.test(value)) {
          callback(new Error('请输入正确的数字'))
        }
        callback()
      }
      return {
        totalCount: [
          { required: true, message: '请填写数量', trigger: 'change' },
          { validator: numValidate, trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (new BigNumber(value).isLessThanOrEqualTo(0)) {
                callback(new Error('发货数量有误'))
              }
              callback()
            }, trigger: 'change'
          },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
      }
    },
    dataRule () {
      return {
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }],
        taxCode: [
          { required: true, message: '请填写税号', trigger: 'change' }],
        shipDate: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    showPurchaseDialog () {
      let exIds = this.dataForm.detailList.filter(item => this.$c.str2bool(item.purchaseId)).map(item => item.purchaseId)
      this.$refs.PurchaseDialog.init(exIds)
    },
    //选择采购单回调
    purchaseSelected (data) {
      console.log(data)
      let tmp = this.dataForm.detailList
      data.forEach(item => {
        if (tmp.find(t => t.makeDetailId === item.id)) {
          return
        }
        tmp.push({
          purchaseId: item.id,
          agreementCode: item.orderCode,
          factoryId: this.dataForm.isOldStore==='否'?item.companyId:this.sendFactory.id,
          factoryName: this.dataForm.isOldStore==='否'?item.companyName:this.sendFactory.name,
          product: item.product,
          productId: item.productId,
          price: item.amount,
          totalCount: 0,
          isOldStore: this.dataForm.isOldStore
        })
      })
      this.$set(this.dataForm, 'detailList', tmp)
    },
    // 根据加工单发货并创建出库信息--开始
    showMakeDetailDialog (row) {
      let exIds = this.dataForm.detailList.filter(item => this.$c.str2bool(item.makeDetailId)).map(item => item.makeDetailId)
      this.$refs.MakeDetailDialog.init(exIds)
    },
    makeDetailSelected (data) {
      let tmp = this.dataForm.detailList
      data.forEach(item => {
        if (tmp.find(t => t.makeDetailId === item.id)) {
          return
        }
        console.log(item)
        tmp.push({
          makeId: item.makeId,
          makeDetailId: item.id,
          agreementCode: item.orderCode,
          factoryId: item.sellerId,
          factoryName: item.sellerName,
          product: item.product,
          productId: item.productId,
          price: item.orderPrice,
          totalCount: 0,
          isOldStore: '否'
        })
      })
      this.$set(this.dataForm, 'detailList', tmp)
    },
    /*根据加工单发货并创建出库信息--结束*/
    async queryCustomerList () {
      const data = await this.$api2.get(`/erp/customer/page`, { params: { page: 1, limit: 100000 } })
      this.customerList = data.list
    },
    //客户下拉列表选择事件
    customerChanged (e) {
      let customer = this.customerList.find(item => item.id === e)
      if (!customer) {
        return
      }
      this.dataForm.taxCode = customer.receiptCode
      this.dataForm.bank = customer.bankName
      this.dataForm.accountCode = customer.bankCode
    },
    init () {
      this.queryCustomerList()
      this.dataForm = {
        detailList: [],
        taxCode: '',
        receiverId: '',
        customerId: '',
        bank: '',
        accountCode: '',
        formType: 'sell'
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    delRow (index) {
      this.dataForm.detailList.splice(index, 1)
    },
    showSelStoreLogDialog () {
      if (!this.dataForm.customerId) {
        return this.$message.error('请先选择客户')
      }
      if (!this.dataForm.receiverId) {
        return this.$message.error('请先选择收货工厂')
      }
      let filterIds = this.dataForm.detailList.map(item => item.storeLogId)
      this.$refs.SelStoreLog.init(this.dataForm.customerId, this.dataForm.receiverId, filterIds)
    },
    storeLogSelected (data) {
      if (this.$c.isArrayEmpty(data)) {
        return
      }
      this.dataForm.detailList = this.dataForm.detailList.concat(data.map(row => {
        return {
          storeLogId: row.id,
          agreementCode: row.orderCode,
          factoryId: row.senderId,
          factoryName: row.senderName,
          product: row.product,
          totalCount: row.sendCount,
          price: row.price,
          preBoxCount: '',
          boxCount: '',
          boxLong: '',
          boxWidth: '',
          boxHeight: '',
          weight: ''
        }
      }))
    },
    async doSave () {
      let postForm = {
        ...this.dataForm
      }
      postForm.detailList.forEach(item => {
        if (String(item.id).length < 4) {
          item.id = null
        }
      })
      let url = this.id ? '/erp/box/update' : '/erp/box/save'
      let loading = this.$loading()
      try {
        const res = await this.$api2.post(url, postForm)
        loading.close()
        this.$message.success(this.$t('prompt.success'))
        this.$emit('change')
        this.visible = false
      } catch (e) {
        loading.close()
      }
    },
    doSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
